import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Card, CardBody, Col, Row } from "reactstrap"
import changeNumberFormat from "../../helpers/changeNumberFormat"
import {Link} from "react-router-dom"
import { Tooltip } from 'antd'

class StaticsTotal extends Component {
    render() {
        const { statistics } = this.props
        const { waiting_process, in_production, waiting_package, labelled, ship_overdue_total } = statistics

        return (
            <div className="StaticsTotal">
                <div className="static-boxes" style={{ gridTemplateColumns: ship_overdue_total > 0 ? 'repeat(5, 1fr)' : 'repeat(4, 1fr)' }}>
                    <Card>
                        <div className="card-header bg-warning text-white header-elements-inline">
                            <h2 className="card-title"><i className="icon-file-text" /> Đơn chờ xử lý</h2>
                        </div>
                        <CardBody>
                            <Tooltip title="Các đơn pending/ on-hold">
                                <h3 className='font-weight-semibold mb-0'>{changeNumberFormat(waiting_process)}</h3>
                            </Tooltip>

                            <span className="text-muted font-size-sm">Số đơn hàng chờ xử lý</span>
                        </CardBody>
                    </Card>
                    <Card>
                        <div className="card-header bg-warning text-white header-elements-inline">
                            <h2 className="card-title"><i className="icon-printer" />Đơn đang xử lý</h2>
                        </div>
                        <CardBody>
                            <Tooltip title="Các đơn đang inproduction - chưa QC hoàn thành">
                                <h3 className='font-weight-semibold mb-0'>{changeNumberFormat(in_production)}</h3>
                            </Tooltip>

                            <span className="text-muted font-size-sm">Số đơn hàng đang xử lý</span>
                        </CardBody>
                    </Card>
                    <Card>
                        <div className="card-header bg-warning text-white header-elements-inline">
                            <h2 className="card-title"><i className="fa fa-cube" />Đơn chờ đóng gói</h2>
                        </div>
                        <CardBody>
                            <Tooltip title="Các đơn đang inproduction - đã QC hoàn thành">
                                <h3 className='font-weight-semibold mb-0'>{changeNumberFormat(waiting_package)}</h3>
                            </Tooltip>

                            <span className="text-muted font-size-sm">Số đơn hàng đang chờ đóng gói</span>
                        </CardBody>
                    </Card>
                    <Card>
                        <div className="card-header bg-warning text-white header-elements-inline">
                            <h2 className="card-title"><i className="icon-truck" />Đơn chờ đóng thùng</h2>
                        </div>
                        <CardBody>
                            <Tooltip title="Các đơn labelled">
                                <h3 className='font-weight-semibold mb-0'>{changeNumberFormat(labelled)}</h3>
                            </Tooltip>

                            <span className="text-muted font-size-sm">Số đơn hàng đang chờ đóng thùng</span>
                        </CardBody>
                    </Card>
                    {
                        ship_overdue_total > 0 &&
                        <Card>
                            <div className="card-header bg-warning text-white header-elements-inline">
                                <h2 className="card-title text-danger"><i className="fa fa-clock-o" />Thùng quá hạn ship</h2>
                            </div>
                            <CardBody>
                                <Link
                                    to={{
                                        pathname: "/next-boxes",
                                        search: '?status=ship_overdue'
                                    }}
                                    className='font-weight-semibold mb-0 cursor-pointer'
                                    target={'_blank'}
                                >
                                    <h3 className='font-weight-semibold mb-0 cursor-pointer'>{changeNumberFormat(ship_overdue_total)}</h3>
                                </Link>
                                <span className="text-muted font-size-sm">Số lượng thùng đang bị quá hạn ship</span>
                            </CardBody>
                        </Card>
                    }
                </div>
            </div >
        )
    }
}

StaticsTotal.propTypes = {
    statistics: PropTypes.object.isRequired
}

export default StaticsTotal
